/**
 * External scheduling link behind the "book a meeting" CTA.
 *
 * This is the *only* way to reach us from the landing now that the contact form
 * is gone, so the button renders unconditionally and this must always hold a
 * real URL. Leaving it empty doesn't degrade gracefully any more — it strands
 * the whole CTA section with nothing to click.
 */
// paltalabs.io/cal redirects (vercel.json) to the founders' shared Google Calendar booking page, so
// the destination can change in one place without touching the CTAs.
export const CALENDAR_URL = 'https://paltalabs.io/cal';
